module.exports = __webpack_public_path__ + "static/media/3d-button.47a9f866.png";